var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHarmony(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180 179.51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(180 0 0 -179.51 -36456 98005.23)",
    gradientUnits: "userSpaceOnUse",
    x1: 202.93,
    x2: 203.8,
    y1: 544.7,
    y2: 545.57
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69fabd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m201.17 60a38.81 38.81 0 0 0 -38.84 38.71v42.92c-4 .27-8.09.44-12.33.44s-8.31.17-12.33.41v-43.77a38.84 38.84 0 0 0 -77.67 0v102.58a38.84 38.84 0 0 0 77.67 0v-42.92c4-.27 8.09-.44 12.33-.44s8.31-.17 12.33-.41v43.77a38.84 38.84 0 0 0 77.67 0v-102.58a38.81 38.81 0 0 0 -38.83-38.71zm-102.34 15.86a22.91 22.91 0 0 1 22.92 22.85v45.45a130.64 130.64 0 0 0 -33 9.33 60 60 0 0 0 -12.8 7.64v-62.42a22.91 22.91 0 0 1 22.88-22.85zm22.92 125.43a22.92 22.92 0 1 1 -45.84 0v-10.29c0-9.09 7.2-17.7 19.27-23.06a113 113 0 0 1 26.57-7.77zm79.42 22.85a22.91 22.91 0 0 1 -22.92-22.85v-45.45a130.64 130.64 0 0 0 33-9.33 60 60 0 0 0 12.8-7.64v62.42a22.91 22.91 0 0 1 -22.88 22.85zm3.65-92.14a113 113 0 0 1 -26.57 7.77v-41.06a22.92 22.92 0 1 1 45.84 0v10.29c0 9.05-7.2 17.66-19.27 23z",
    fill: "url(#a)",
    transform: "translate(-60 -60)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmony);
export default __webpack_public_path__ + "static/media/harmony.aacf0e8f87742288170ab2a99e3774c0.svg";
export { ForwardRef as ReactComponent };